import Security from 'assets/icons/fa/security.svg'

Security.displayName = 'Security'
export default Security
